import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import KickLoginButton from './KickLoginButton';

const LoginPage = () => {
  const navigate = useNavigate();

  return (
    <div className="login-page">
      <Helmet>
        <title>Login - Watch Streams</title>
        <meta name="description" content="Connect Twitch, YouTube (Google) and Kick accounts to Watch Streams." />
      </Helmet>

      <section>
        <h1>Connect Accounts</h1>
        <p>Sign in with one or more providers to enable features that require authentication.</p>
      </section>

      <section className="login-buttons">
        <KickLoginButton />
      </section>

      <section className="back">
        <button className="button primary small" onClick={() => navigate('/')}>Back to Home</button>
      </section>
    </div>
  );
};

export default LoginPage;